export default __webpack_public_path__ + "static/media/camilo.d86590af.png";